import React, { useState, useEffect } from 'react'
import { getRequest } from '../../globalhelper/helper'
import '../CI/COD.css'
import VR2_Forms from '../../pages/VR2_Form_Rendering/displayContainer'
import ApiConstants from '../../config'
import download from 'downloadjs'
import axios from 'axios'
import { connect, useDispatch } from 'react-redux'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  AlertTitle,
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ArticleIcon from '@mui/icons-material/Article'
import DialougeBox from '../VR2_Form_Rendering/DialougeBox'
import { showAlert } from '../../redux/Common/commonActions'
import { CSVLink } from 'react-csv'
import { GetApp } from '@material-ui/icons'
import moment from 'moment'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
const PO_Dropdown = ({ login, onBack }) => {
  const [state, setState] = useState({
    showtable: false,
    formData: {
      orgname: '',
      date: null,
      vendorname: '',
      ponumber: '',
      vendorid: '',
      organizationid: '',
      taxcode: '',
      periodfrom: '',
      periodto: '',
      status: '',
      period: null
    },
    tableData: [],
    displayData: [],
    dropdown_orgname: [],
    dropdown_vendorname: [],
    dropdown_vendorid: [],
    dropdown_ponumber: [],
    dropdown_organizationid: [],
    dropdown_taxcode: [],
    dropdown_status: [],
    companyDetails: [],
    error: false,
    errorMessage: '',
    redirect: false,
    SearchJSON: [],
    ConfirmDialogBox: null,
    DialogBox: null
  })
  let [emailID, setEmailID] = useState('')
  let [showDialog, setShowDialog] = useState(false)
  let [dialogItem, setDialogItem] = useState(null)

  let dispatch = useDispatch()

  useEffect(() => {
    sessionStorage.setItem('pageName', 'Search PurchaseOrder')

    // Fetch company data
    getRequest(`api/edureka/getCompanyAssignedToUser`)
      .then(response => {
        const responseData = response.res.data
        const arr = responseData.map(item => item.orgname)
        setState(prev => ({
          ...prev,
          dropdown_orgname: arr,
          companyDetails: responseData
        }))
      })
      .catch(err => console.log(err))

    // Fetch PO status values
    getRequest(`api/edureka/getPORemainingValues`).then(res => {
      setState(prev => ({
        ...prev,
        dropdown_status: res.res.data
      }))
    })
  }, [])

  useEffect(() => {
    if (state.dropdown_orgname.length === 1) {
      handleChange('orgname', state.dropdown_orgname[0])
    }
  }, [state.companyDetails])

  const handleChange = (name, value) => {
    setState(prev => ({
      ...prev,
      formData: {
        ...prev.formData,
        [name]: value || ''
      }
    }))
    console.log(value)

    if (name === 'orgname' && value !== null) {
      handleRemainingAPIs(value)
    }
  }

  const handleSearch = () => {
    const { orgname } = state.formData

    if (!orgname) {
      setState(prev => ({
        ...prev,
        error: true,
        errorMessage: 'Please select all the required fields'
      }))
      return
    }

    const { ponumber, vendorname, vendorid, status, date } = state.formData

    const poDate = date
      ? moment(date).format('YYYY-MM-DD')
      : ''

    const id = state.companyDetails.filter(item => item.orgname === orgname)
    const companyid = id.map(item => item.orgid)

    getRequest(
      `api/edureka/getPOData?ponumber=${ponumber}&vendorname=${vendorname}&orgid=${companyid[0]}&status=${status}&vendorid=${vendorid}&date=${poDate}`
    ).then(res => {
      const temp = JSON.parse(res.res.data)

      setState(prev => ({
        ...prev,
        tableData: temp,
        displayData: temp,
        showtable: !!temp.length,
        error: !temp.length,
        errorMessage: temp.length
          ? ''
          : 'No data found. Please try some other combination'
      }))
    })
  }

  const handlePO = item => {
    const ponumber = item['PO Number']
    const id = state.companyDetails.filter(
      item => item.orgname === state.formData.orgname
    )
    const companyid = id.map(item => item.orgid)
    localStorage.setItem(
      'api',
      `api/edureka/getUpdatedDataFromDB`
    )
    localStorage.setItem('apiParams', JSON.stringify({
      "LDE": {
        "Organization ID": companyid[0],
        "PO Number": ponumber,
      },
      "Module": localStorage.getItem('module'),
      "screenName": "PurchaseOrder"
    }))
    window.open(
      `/Dynamic_Forms?token=PurchaseOrder&action=edit&orgId=${companyid[0]}&docId=${ponumber}`,
      '_blank'
    )
    // getRequest(
    //   `api/edureka/getPOUpdatedJSON?ponumber=${ponumber}&orgid=${companyid[0]}`
    // ).then(res => {
    //   if (res.res.status === 'success') {
    //     setState(prev => ({
    //       ...prev,
    //       redirect: true,
    //       SearchJSON: res.res.data
    //     }))
    //   }
    // })
  }

  const handleReset = () => {
    setState(prev => ({
      ...prev,
      showtable: false,
      error: false,
      formData: {
        ...prev.formData,
        vendorname: '',
        ponumber: '',
        vendorid: '',
        status: '',
        orgname: '',
        period: null,
        date: null,
      }
    }))
  }

  const openEmailDialog = item => {
    setDialogItem(item)
    setShowDialog(true)
  }

  const sendEmailToVendor = item => {
    setState(prev => ({
      ...prev,
      ConfirmDialogBox: (
        <DialougeBox
          status={'warning'}
          message={`Are you sure you want to send this PO to vendor?`}
          onClose={() =>
            setState(prev => ({ ...prev, ConfirmDialogBox: null }))
          }
          operation={() => {
            setState(prev => ({ ...prev, ConfirmDialogBox: null }))

            const id = state.companyDetails.filter(
              i => i.orgname === state.formData.orgname
            )
            const companyid = id.map(i => i.orgid)

            axios
              .post(
                ApiConstants.externals.serverUrl + `api/edureka/sendPOtoVendor`,
                {
                  filename: item['PO Number'],
                  vendorEmailID: item['Vendor EmailID'],
                  VendorID: item['Vendor ID'],
                  tenantid: login?.userData?.USR_Tenant || '',
                  orgid: companyid[0],
                  orgname: state.formData.orgname
                },
                { responseType: 'blob' }
              )
              .then(() => {
                dispatch(showAlert('Successfully sent PO to vendor'))
              })
              .catch(error => {
                dispatch(showAlert(error || 'Server error sending PO', 'error'))
              })
          }}
        />
      )
    }))
  }

  const submitEmail = () => {
    setShowDialog(false)

    sendtoVendor({
      ...dialogItem,
      'Vendor EmailID': emailID
    })
  }

  const sendtoVendor = item => {
    if (!item['Vendor EmailID'] || item['Vendor EmailID'] === '') {
      openEmailDialog(item)
      return
    }
    sendEmailToVendor(item)
  }

  const getPOasDocument = async item => {
    try {
      console.log(item)

      const id = state.companyDetails.filter(
        item => item.orgname === state.formData.orgname
      )
      const companyid = id.map(item => item.orgid)
      let response = await axios.post(
        ApiConstants.externals.serverUrl + `api/edureka/getPOasDocument`,
        {
          filename: item['PO Number'],
          tenantid: login?.userData?.USR_Tenant || '', // Safe access with optional chaining
          orgid: companyid[0],
          orgname: state.formData.orgname
        },
        { responseType: 'blob' }
      )
      console.log(response)
      if (response) {
        let fileURL = URL.createObjectURL(response.data)
        setState({
          ...state,
          DialogBox: (
            <Dialog
              open={true}
              onClose={() => setState(prev => ({ ...prev, DialogBox: null }))}
              fullWidth
              maxWidth='lg'
            >
              <DialogContent sx={{ p: 2 }}>
                <Box sx={{ height: '500px', flex: 1 }}>
                  {/* PDF Viewer */}
                  <iframe
                    src={fileURL}
                    title='pdf-viewer'
                    style={{ width: '100%', height: '90%' }}
                  />
                  <Grid container spacing={1} justifyContent={'flex-end'}>
                    {!item['Vendor EmailID'] && (
                      <Grid item>
                        <Alert severity='error'>
                          <Typography variant='caption'>
                            Vendor email ID is missing to send PO user should
                            provide vendor email ID{' '}
                          </Typography>
                        </Alert>
                      </Grid>
                    )}
                    <Grid item>
                      <Button
                        color='primary'
                        variant='contained'
                        onClick={() => {
                          sendtoVendor(item)
                        }}
                      >
                        Send To Vendor
                      </Button>
                    </Grid>
                    <Grid item xl={1}>
                      <Button
                        color='error'
                        variant='contained'
                        onClick={() => {
                          setState({ ...state, DialogBox: null })
                        }}
                      >
                        Close
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </DialogContent>
            </Dialog>
          )
        })
      }
    } catch (error) {
      console.log(error)
      dispatch(showAlert('Error while get PO as PDF Document', 'error'))
    }
  }

  const handleBack = () => {
    setState(prev => ({
      ...prev,
      redirect: false,
      SearchJSON: []
    }))
  }

  const handleRemainingAPIs = value => {
    const id = state.companyDetails.filter(item => item.orgname === value)
    const companyid = id.map(item => item.orgid)
    console.log(value, state.companyDetails, id, companyid)

    // Fetch vendor data
    getRequest(`api/edureka/getPOVendor?orgid=${companyid[0]}`).then(res => {
      const responseData = JSON.parse(res.res.data)
      const vendorName = responseData
        .map(item => item['Vendor Name'])
        ?.sort((a, b) => a.localeCompare(b))
      const vendorID = responseData
        .map(item => item['Vendor ID'])
        ?.sort((a, b) => a.localeCompare(b))

      setState(prev => ({
        ...prev,
        dropdown_vendorname: vendorName,
        dropdown_vendorid: vendorID
      }))
    })

    // Fetch PO numbers
    getRequest(`api/edureka/getPOTaxCode?orgid=${companyid[0]}`).then(res => {
      const responseData = JSON.parse(res.res.data)
      const PONumber = responseData
        .map(value => value['PO Number'])
        ?.sort((a, b) => a.localeCompare(b))

      setState(prev => ({
        ...prev,
        dropdown_ponumber: PONumber
      }))
    })
  }

  useEffect(() => {
    if (!state.formData.period) return

    // if your period is '2025-10'
    const startDate = moment(state.formData.period, 'YYYY-MM').startOf('month')
    const endDate = moment(state.formData.period, 'YYYY-MM').endOf('month')

    const filtered = state.tableData.filter(item => {
      // parse with correct format (DD/MM/YYYY)
      const itemDate = moment(
        item?.['Created At'],
        [
          'YYYY-MM-DDTHH:mm:ss.SSSZ',
          'YYYY-MM-DD HH:mm:ss',
          'YYYY-MM-DD',
          'DD/MM/YYYY'
        ],
        true
      )
      return (
        itemDate.isSameOrAfter(startDate) && itemDate.isSameOrBefore(endDate)
      )
    })
    console.log(filtered)

    setState(prev => ({
      ...prev,
      displayData: filtered
    }))
  }, [state.formData.period])

  if (state.redirect) {
    return (
      <VR2_Forms
        screenName={'PurchaseOrder'}
        screenAction={'edit'}
        From_SearchJSON={state.SearchJSON}
        onBack={handleBack}
      />
    )
  }

  return (
    <>
      {showDialog && (
        <Dialog open onClose={() => setShowDialog(false)}>
          <DialogContent sx={{ p: 2 }}>
            <Alert severity='info'>Enter Vendor's Email ID</Alert>

            <TextField
              sx={{ m: 1, width: 300 }}
              label='Email ID'
              placeholder='ex: ABC@gmail.com'
              fullWidth
              value={emailID}
              onChange={e => setEmailID(e.target.value)}
            />

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
              <Button
                variant='contained'
                color='success'
                disabled={!emailID}
                onClick={submitEmail}
              >
                Submit
              </Button>

              <Button
                variant='contained'
                color='error'
                onClick={() => setShowDialog(false)}
              >
                Cancel
              </Button>
            </Box>
          </DialogContent>
        </Dialog>
      )}

      {state.ConfirmDialogBox}
      {state.DialogBox}
      <Accordion defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant='h6'>Search PO</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container gap={2} spacing={3}>
            <Grid item xs={6} sm={6} md={3} lg={2}>
              <Autocomplete
                fullWidth
                options={state.dropdown_orgname}
                value={state.formData.orgname}
                onChange={(e, newValue) => handleChange('orgname', newValue)}
                renderInput={params => (
                  <TextField
                    {...params}
                    label='Organization Name'
                    variant='outlined'
                    size='small'
                  />
                )}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={2}>
              <Autocomplete
                fullWidth
                options={state.dropdown_ponumber}
                value={state.formData.ponumber}
                onChange={(e, newValue) => handleChange('ponumber', newValue)}
                renderInput={params => (
                  <TextField
                    {...params}
                    label='PO Number'
                    variant='outlined'
                    size='small'
                  />
                )}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={2}>
              <Autocomplete
                fullWidth
                options={state.dropdown_vendorid}
                value={state.formData.vendorid}
                onChange={(e, newValue) => handleChange('vendorid', newValue)}
                renderInput={params => (
                  <TextField
                    {...params}
                    label='Vendor ID'
                    variant='outlined'
                    size='small'
                  />
                )}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={2}>
              <Autocomplete
                fullWidth
                options={state.dropdown_vendorname}
                value={state.formData.vendorname}
                onChange={(e, newValue) => handleChange('vendorname', newValue)}
                renderInput={params => (
                  <TextField
                    {...params}
                    label='Vendor Name'
                    variant='outlined'
                    size='small'
                  />
                )}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={2}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DatePicker
                  label="PO Date"
                  value={state.formData.date}
                  onChange={(newValue) => handleChange('date', newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      size="small"
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={6} sm={6} md={3} lg={2}>
              <Autocomplete
                fullWidth
                options={state.dropdown_status}
                value={state.formData.status}
                onChange={(e, newValue) => handleChange('status', newValue)}
                renderInput={params => (
                  <TextField
                    {...params}
                    label='Status'
                    variant='outlined'
                    size='small'
                  />
                )}
              />
            </Grid>
            {state.tableData.length > 0 && (
              <Grid item xs={1} sm={2} md={3}>
                <LocalizationProvider dateAdapter={AdapterMoment}>
                  <DatePicker
                    label='Period'
                    value={state.formData.period}
                    views={['month', 'year']}
                    onChange={newValue => {
                      handleChange('period', newValue)
                    }}
                    renderInput={params => (
                      <TextField fullWidth size='small' {...params} />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
            )}
            <Grid item md={4}>
              <Button
                variant='contained'
                color='primary'
                onClick={handleSearch}
              >
                Search
              </Button>
              &nbsp;
              <Button variant='contained' color='error' onClick={handleReset}>
                Reset
              </Button>
              &nbsp;
              <Button
                variant='contained'
                color='warning'
                onClick={() => onBack()}
              >
                Back
              </Button>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>

      <br />

      {(state.showtable && state.tableData.length > 0 && (
        <>
          <Box align='right'>
            <Button color='success' variant='contained'>
              <CSVLink
                style={{ color: 'white', textDecoration: 'none' }}
                data={state.tableData}
                filename='PO.csv'
              >
                <GetApp />
              </CSVLink>
            </Button>
          </Box>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }}>
              <TableHead>
                <TableRow>
                  <TableCell>PO Number</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell>Vendor ID</TableCell>
                  <TableCell>Vendor Name</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Created At</TableCell>
                  <TableCell>Show Document</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(state.displayData.length > 0 &&
                  state.displayData
                    .sort((a, b) =>
                      a['PO Number'].localeCompare(b['PO Number'])
                    )
                    .map((item, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          <Button onClick={() => handlePO(item)}>
                            {item['PO Number']}
                          </Button>
                        </TableCell>
                        <TableCell>
                          {moment(item['Date']).format('DD/MM/YYYY')}
                        </TableCell>
                        <TableCell>{item['Vendor ID']}</TableCell>
                        <TableCell>{item['Vendor Name']}</TableCell>
                        <TableCell>{item['Status']}</TableCell>
                        <TableCell>
                          {moment(item['Created At']).format('DD/MM/YYYY')}
                        </TableCell>
                        <TableCell>
                          <IconButton
                            color='primary'
                            onClick={() => getPOasDocument(item)}
                          >
                            <ArticleIcon />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))) || (
                    <TableRow>
                      <TableCell colSpan={7}>
                        <Box
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '100%'
                          }}
                        >
                          <Alert severity='error' variant='outlined'>
                            No matching records found. Please adjust your search criteria.
                          </Alert>
                        </Box>
                      </TableCell>
                    </TableRow>
                  )}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )) ||
        (state.showtable && state.tableData.length === 0 && (
          <Box sx={{ margin: 'auto' }}>
            <Alert severity='warning'>
              <AlertTitle>No Data Found</AlertTitle>
              There is no data to display at the moment.
            </Alert>
          </Box>
        ))}

      {state.error && <div className='center-screen'>{state.errorMessage}</div>}
    </>
  )
}

const mapStateToProps = state => ({
  login: state.login // Directly map login from state
})

export default connect(mapStateToProps)(PO_Dropdown)